import './LicenseManagement.scss';

import React, { useEffect, useState } from 'react';

import { IOrganisationState } from '../../commonUtils/Redux/Global/globalShared';
import { LandingPage } from '@bmsp/bmsp.webcomponent.license.management';
import { User } from 'oidc-client';
import { authService } from '../../../auth/services';
import {
  getFeatureFlagValuebasedOnSIOrg
} from '../../commonUtils/LDFlagUtils';
import i18next from '../../../i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AuthenticatedUser } from '../../../auth/models';

interface IPermission {
  name: string;
}

interface ILicenseManagementProps {
  loggedInUser: AuthenticatedUser | null;
}

export const LicenseManagement: React.FC<ILicenseManagementProps> = ({
  loggedInUser
}) => {
  const [userPrivileges, setUserPrivileges] = useState<IPermission[]>([]);

  const orgSelected = useSelector(
    (state: IOrganisationState) =>
      state.globalShared.gatewaySelectedOrganisation
  );
  const history = useHistory();

  // Fetch LicenseManagement user-all-privileges
  useEffect(() => {
    authService.fetchUserAllPrivileges('LicenseManagement').then(setUserPrivileges);
  }, []);

  useEffect(() => {
    const handleNavigation = (event: CustomEvent) => {
      const { path, params } = event.detail;
      const fullPath = `${path}?${new URLSearchParams(params)}`;
      history.push(fullPath);
    };

    window.addEventListener(
      'bmsp:organization-license-tab',
      handleNavigation as EventListener
    );
    return () => {
      window.removeEventListener(
        'bmsp:organization-license-tab',
        handleNavigation as EventListener
      );
    };
  }, [history]);

  const featureFlags = useFlags();
  const organisations = useSelector(
    (state: IOrganisationState) => state.globalShared.organisationList
  );

  let licenseStatus = '';
  const queryParams = new URLSearchParams(window.location.search);
  if (queryParams.has('license-status')) {
    licenseStatus = queryParams.get('license-status') || '';
  }

  const licenseManagementProps = {
    ...orgSelected,
    featureFlags: {
      ...featureFlags,
      enableBacsFlowDistributor:
        featureFlags['enableBacsFlowDistributor'] ?? false,
      enableARRLicenseOverviewAndDownloadForSI: authService.isLicensePrivilegedUser
    },
    globalPermissions: userPrivileges,
    i18Lng: i18next as any,
    licenseStatus,
    onCustomerClick: (customerId: string, customerName: string) => {
      history.push(
        `/app/feature/organisations?customerId=${customerId}&orgName=${customerName}`
      );
    },
    onSiteClick: (siteId: string, siteName: string) => {
      history.push(`/app/feature/home?siteId=${siteId}&siteName=${siteName}`);
    },
  };
  return (
    <>
      <div className="arr-license-container">
        {orgSelected && (
          <LandingPage
            selectedSIOrg={orgSelected}
            {...licenseManagementProps}
          />
        )}
      </div>
    </>
  );
};
export default LicenseManagement;
